<template>
  <div class="container">
    <!-- 创建一个canvas画布 npmn-js是通过canvas实现绘图的，并设置ref让vue获取到element -->
    <div class="bpmn-canvas" ref="canvas"></div>
    <!-- 工具栏显示的地方 -->
    <div class="bpmn-js-properties-panel" id="js-properties-panel"></div>
    <!-- 把操作按钮写在这里面 -->
    <div class="action">
      <!-- <a-button type="primary" @click="getFilename">console.log</a-button>
      <a-divider type="vertical" /> -->
      <a-upload
        name="file"
        :fileList="fileList"
        :multiple="true"
        @change="handleChange"
      >
        <a-button type="primary"> <a-icon type="upload" /> 导入文件 </a-button>
      </a-upload>
      <a-divider type="vertical" />
      <!-- <a-button type="primary" @click="downloadBpmnCamunda">
        导出前端视图解析的camunda文件
      </a-button> -->
      <!-- <a-divider type="vertical" /> -->
      <a-button type="primary" @click="downloadBpmnActiviti">
        导出工作流文件
      </a-button>
      <a hidden ref="downloadLink"></a>
    </div>
  </div>
</template>

<script>
import BpmnModeler from 'bpmn-js/lib/Modeler'
// 工具栏相关
import propertiesProviderModule from 'bpmn-js-properties-panel/lib/provider/camunda'
import propertiesPanelModule from 'bpmn-js-properties-panel'
import camundaModdleDescriptor from 'camunda-bpmn-moddle/resources/camunda'
// 汉化
import customTranslate from '@/avtiviti/customTranslate'
import { addDeploymentByString } from '@/http/url'

export default {
  data() {
    return {
      fileList: [],
      bpmnModeler: null,
      canvas: null,
      bpmnTemplate: `<?xml version="1.0" encoding="UTF-8"?>
<bpmn2:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" 
xmlns:bpmn2="http://www.omg.org/spec/BPMN/20100524/MODEL" 
xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" 
xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" 
xmlns:di="http://www.omg.org/spec/DD/20100524/DI" 
xmlns:camunda="http://camunda.org/schema/1.0/bpmn" 
xmlns:activiti="http://activiti.org/bpmn" id="sample-diagram" targetNamespace="http://activiti.org/bpmn" xsi:schemaLocation="http://www.omg.org/spec/BPMN/20100524/MODEL BPMN20.xsd">
  <bpmn2:process id="Process_1" isExecutable="true">
    <bpmn2:startEvent id="StartEvent_1"/>
  </bpmn2:process>
  <bpmndi:BPMNDiagram id="BPMNDiagram_1">
    <bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_1">
      <bpmndi:BPMNShape id="_BPMNShape_StartEvent_2" bpmnElement="StartEvent_1">
        <dc:Bounds height="36.0" width="36.0" x="412.0" y="240.0"/>
      </bpmndi:BPMNShape>
    </bpmndi:BPMNPlane>
  </bpmndi:BPMNDiagram>
</bpmn2:definitions>`
    }
  },
  methods: {
    // 导入
    removeFiles() {},
    handleChange(file) {
      let fileOriginFileObj = file.file.originFileObj
      const reader = new FileReader()
      // 读取File对象中的文本信息，编码格式为UTF-8
      reader.readAsArrayBuffer(fileOriginFileObj)
      reader.onload = () => {
        let utf8decoder = new TextDecoder() // default 'utf-8' or 'utf8'
        let buffer = reader.result
        let binary = new Uint8Array(buffer)
        let utf8decodeBinary = utf8decoder.decode(binary)
        let v = utf8decodeBinary.replace(/activiti:/g, 'camunda:')
        //读取完毕后将文本信息导入到Bpmn建模器
        this.createNewDiagram(v)
      }
      return false
    },
    // 导出 文件
    download({ name = 'diagram.bpmn', data }) {
      // 这里就获取到了之前设置的隐藏链接
      const downloadLink = this.$refs.downloadLink
      // 把数据转换为URI，下载要用到的
      const encodedData = encodeURIComponent(data)
      if (data) {
        // 将数据给到链接
        downloadLink.href =
          'data:application/bpmn20-xml;charset=UTF-8,' + encodedData
        // 设置文件名
        downloadLink.download = name
        // 触发点击事件开始下载
        downloadLink.click()
      }
    },
    getFilename(xml) {
      let start = xml.indexOf('process')
      let filename = xml.substr(start, xml.indexOf('>'))
      filename = filename.substr(filename.indexOf('id') + 4)
      filename = filename.substr(0, filename.indexOf('"'))
      return filename
    },
    // camunda事件
    downloadBpmnCamunda() {
      this.bpmnModeler.saveXML({ format: true }, (err, xml) => {
        if (!err) {
          // 获取文件名
          const name = `camunda解析文件.bpmn`
          // 将文件名以及数据交给下载函数
          this.download({ name: name, data: xml })
        }
      })
    },
    // activiti事件
    downloadBpmnActiviti() {
      this.bpmnModeler.saveXML({ format: true }, (err, xml) => {
        if (!err) {
          let a = xml.replace(/camunda:/g, 'activiti:')
          // 获取文件名
          const name = `activiti解析文件.bpmn`
          // 将文件名以及数据交给下载函数
          this.download({ name: name, data: a })
        }
      })
    },
    // 导出 文件
    // 发布
    getFilename() {
      this.bpmnModeler.saveXML({ format: true }, (err, xml) => {
        if (!err) {
          // 获取文件名
          // const name = `${this.getFilename(xml)}.bpmn`
          // 将文件名以及数据交给下载方法
          // this.download({ name: name, data: xml })
          let a = xml.replace(/camunda:/g, 'activiti:')
          const params = {
            stringBPMN: a
          }
          // addDeploymentByString(params).then((res) => {
          //   if (res.data.code === 200 || res.data.code === 0) {
          //     this.$message.success('创建工作流成功')
          //   } else {
          //     this.$message.error(res.data.msg)
          //   }
          // })
        }
      })
    },
    // getFilename() {
    //   this.createNewDiagram(this.bpmnTemplate)
    // },

    async init() {
      // 获取画布 element
      this.canvas = this.$refs.canvas
      // 将汉化包装成一个模块
      const customTranslateModule = {
        translate: ['value', customTranslate]
      }
      // 创建Bpmn对象
      this.bpmnModeler = new BpmnModeler({
        // 设置bpmn的绘图容器为上门获取的画布 element
        container: this.canvas,

        // 加入工具栏支持
        propertiesPanel: {
          parent: '#js-properties-panel'
        },
        additionalModules: [
          propertiesProviderModule,
          propertiesPanelModule,
          // 汉化模块
          customTranslateModule,
          {
            // paletteProvider: ['value', ''], // 禁用左面板
            // labelEditingProvider: ['value', ''], // 禁用编辑
            // contextPadProvider: ['value', ''], // 禁用点击出现的contextPad
            // bendpoints: ['value', {}], // 禁止流程线变换waypoints
            zoomScroll: ['value', 'true'], // 禁止画布滚动
            moveCanvas: ['value', ''] // 禁止拖拽
          }
        ],
        moddleExtensions: {
          activiti: camundaModdleDescriptor
        }
      })

      await this.createNewDiagram(this.bpmnTemplate)
    },
    async createNewDiagram(bpmn) {
      // 将字符串转换成图显示出来;
      this.bpmnModeler.importXML(bpmn, (err) => {
        if (err) {
          this.$Message.error('打开模型出错,请确认该模型符合Bpmn2.0规范')
        } else {
        }
      })
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style scoped>
.container {
  height: 100vh;
  overflow: hidden;
}
.bpmn-canvas {
  height: 100%;
}
.bpmn-canvas {
  width: 100%;
  height: 100vh;
}

.action {
  position: fixed;
  bottom: 10px;
  left: 10px;
  display: flex;
}
.upload-demo {
  margin-right: 10px;
}

.bpmn-js-properties-panel {
  position: absolute;
  top: 0;
  right: 0px;
  width: 300px;
}
</style>


// WEBPACK FOOTER //
// src/views/system/activitiList/createActiviti.vue